module.exports = __webpack_public_path__ + "img/41.62ff25fb.png";